var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6181 11.07C22.5681 10.56 22.1381 10.18 21.6281 10.18H14.0781C13.5281 10.18 13.0781 10.63 13.0781 11.18V12.89C13.0781 13.44 13.5281 13.89 14.0781 13.89H18.5881C18.4781 14.81 17.8781 16.2 16.5481 17.13C15.6981 17.72 14.5681 18.13 13.0781 18.13C13.0081 18.13 12.9481 18.13 12.8781 18.12C10.3281 18.04 8.16813 16.33 7.38813 13.98C7.17813 13.35 7.05813 12.69 7.05813 12C7.05813 11.31 7.17813 10.64 7.37813 10.02C7.43813 9.83999 7.50813 9.66001 7.58813 9.48001C8.50813 7.41001 10.5181 5.95 12.8781 5.88C12.9381 5.87 13.0081 5.87 13.0781 5.87C14.5081 5.87 15.5781 6.33999 16.3281 6.85999C16.7181 7.12999 17.2381 7.06999 17.5781 6.73999L18.9681 5.38C19.4081 4.95 19.3681 4.21999 18.8681 3.85999C17.2781 2.68999 15.3381 2 13.0781 2C13.0081 2 12.9481 2.00001 12.8781 2.01001C9.04813 2.08001 5.75812 4.30001 4.14812 7.51001C3.46812 8.87001 3.07812 10.39 3.07812 12C3.07812 13.61 3.46812 15.13 4.14812 16.49H4.15813C5.76813 19.7 9.05813 21.92 12.8781 21.99C12.9481 22 13.0081 22 13.0781 22C15.7781 22 18.0481 21.11 19.6981 19.58C21.5881 17.83 22.6781 15.27 22.6781 12.22C22.6781 11.79 22.6581 11.42 22.6181 11.07Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1ad5c76f7993f440f285817fe07faa34.svg";
export { ForwardRef as ReactComponent };